import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import * as packageSlice from "../../../../redux/slices/packageSlice";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import * as templeSlice from "../../../../redux/slices/templeSlice";
import * as customizeSlice from "../../../../redux/slices/customizeSlice";

const CustomizePricingForm = () => {
  const [templeOptions, setTempleOptions] = useState([]);
  const [selectedVehicleId, setSelectedVehicleId] = useState(null);

  const [formData, setFormData] = useState({
    room_price_per_day: undefined,
    extra_bed_price_per_day: undefined,
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { list, vehicleList } = useSelector((state) => state.templeSlice);
  const { priceData, loading } = useSelector((state) => state.customizeSlice);

  console.log(priceData, "priceData");
  useEffect(() => {
    const pData = priceData?.data;
    setFormData({
      price_per_adult: pData?.price_per_adult || undefined,
      price_per_child: pData?.price_per_child || undefined,
      sedan_price: pData?.sedan_price || undefined,
      suv_price: pData?.suv_price || undefined,
      tempo_traveller_price: pData?.tempo_traveller_price || undefined,
      customized_discount_percentage:
        pData?.customized_discount_percentage || undefined,
      gst_no: pData?.gst_no || undefined,
      hsn_code: pData?.hsn_code || undefined,
    });
  }, [priceData]);

  // console.log(priceData,"priceData")
  // console.log(formData,"priceData2")
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData?.price_per_adult) {
      toast("Please enter price per adult");
      return;
    }
    if (!formData?.price_per_child) {
      toast("Please enter price per child");
      return;
    }
    if (!formData?.customized_discount_percentage) {
      toast("Please enter discount");
      return;
    }
    if (!formData?.gst_no) {
      toast("Please enter gst number");
      return;
    }
    if (!formData?.hsn_code) {
      toast("Please enter hsn code");
      return;
    }
    await dispatch(
      customizeSlice.updateCustomizePrice(formData, priceData?.data?.id)
    );
    dispatch(customizeSlice.getCustomizePrice());
  };

  useEffect(() => {
    dispatch(customizeSlice.getCustomizePrice());
  }, [dispatch]);

  return (
    <>
      <h5 className="mb-3">Price Module</h5>
      {loading ? (
        <div className="w-100 d-flex">
          <div
            className="spinner-border text-primary mx-auto"
            role="status"
          ></div>
        </div>
      ) : (
        <>
          {" "}
          <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="package_name">
                  <Form.Label>
                    Price Per Adult: <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={formData?.price_per_adult}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        price_per_adult: e.target.value,
                      })
                    }
                    placeholder="Enter Price"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group controlId="number_of_days">
                  <Form.Label>
                    Price Per Child <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={formData?.price_per_child}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        price_per_child: e.target.value,
                      })
                    }
                    placeholder="Enter Price"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="number_of_days">
                  <Form.Label>
                    Discount For Customize Trip (%){" "}
                    <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={formData?.customized_discount_percentage}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        customized_discount_percentage: e.target.value,
                      })
                    }
                    placeholder="Enter discount here"
                  />
                </Form.Group>
              </Col>
              <h5 className="mt-4 mb-2">Vehicle Price for 150 km:</h5>
              <Col md={6}>
                <Form.Group controlId="number_of_days">
                  <Form.Label>
                    Sedan Price <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={formData?.sedan_price}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        sedan_price: e.target.value,
                      })
                    }
                    placeholder="Enter Price"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="number_of_days">
                  <Form.Label>
                    SUV Price <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={formData?.suv_price}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        suv_price: e.target.value,
                      })
                    }
                    placeholder="Enter Price"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="number_of_days">
                  <Form.Label>
                    Tempo Traveller Price{" "}
                    <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={formData?.tempo_traveller_price}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        tempo_traveller_price: e.target.value,
                      })
                    }
                    placeholder="Enter Price"
                  />
                </Form.Group>
              </Col>

              <h5 className="mt-4 mb-2">GST Management:</h5>
              <Col md={6}>
                <Form.Group controlId="number_of_days">
                  <Form.Label>
                    GST Number <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={formData?.gst_no}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        gst_no: e.target.value,
                      })
                    }
                    placeholder="Enter GST Number"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="number_of_days">
                  <Form.Label>
                    HSN Number <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={formData?.hsn_code}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        hsn_code: e.target.value,
                      })
                    }
                    placeholder="Enter HSN code"
                  />
                </Form.Group>
              </Col>
            </Row>

            <button type="submit" className="btn_primary text-center">
              Update
            </button>
          </Form>
        </>
      )}
    </>
  );
};

export default CustomizePricingForm;
